<template>
    <div class="md:flex text-center md:space-x-10 space-y-6 md:py-4 md:space-y-0 justify-between items-center">
        <div class="space-y-2 md:text-left text-center">
            <Link
                :href="route('central.register')"
                class="hover:underline font-bold"
            >
                Don't have an account?
            </Link>
            <p class="text-inveloPurple"> Create one in just a few clicks. </p>
        </div>
        <a
            class="invelo-text-gradient block bg-white font-bold uppercase rounded-full px-16 border py-4 shadow-lg
            duration-500 transform transition-all hover:translate-y-1 active:translate-y-1 hover:shadow-md
        "
            href="/register"
        >Sign up</a>
    </div>
</template>
